import axiosInstance from "./axiosInstance";

class EventService {

    static async getEvents(category?: string | null): Promise<any> {
      try {
        const response = await axiosInstance.get<ApiResponse<any>>(`/events/`,
            {
                params: {
                    category
                }
            }
        );
        return response.data.result;
      } catch (error) {
        throw error;
      }
    };
    static async getEventDetail(id?: string): Promise<any> {
        const response = await axiosInstance.get<ApiResponse<any>>(`/event/${id}`
           
        );
        return response.data.result;

    };

}
  
  export default EventService;